import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_SCHOOL_DETAILS } from "./apiRoutes";

// =========================
// Interfaces
// =========================

export interface CurriculumData {
  _id: string;
  curriculum_id: string;
  curriculum_name: string;
}

export interface SchoolDetailsItem {
  _id: string;
  schoolId: string;
  geoRegionId: string;
  schoolName: string;
  state: string;
  city: string;
  gradesSelected: string[];
  facultyDays: string[];
  noOfFacultyDays?: string | null;
  sku: string;
  noOfWorkStations: string | null;
  schoolTier: string;
  syllabus: string[];
  curriculumData: CurriculumData[];
  crmRH: string | null;
  crmRM: string | null;
  regionName: string;
}

export interface SchoolDetailsResponse {
  status: number;
  error: boolean;
  count: number;
  issues: any[];
  data: {
    items: SchoolDetailsItem[];
  };
}

// =========================
// Fetch Function
// =========================

// useGetSchoolDetailsQuery.ts
const fetchSchoolDetails = async (filters?: Record<string, any>): Promise<SchoolDetailsResponse> => {
  const queryString = filters
    ? "?" + new URLSearchParams(filters as Record<string, string>).toString()
    : "";
  const response = await axiosAuth.get(`${GET_SCHOOL_DETAILS}${queryString}`);
  return response.data as SchoolDetailsResponse;
};

export const useGetSchoolDetailsQuery = (
  filters?: Record<string, any>,
  options?: UseQueryOptions<SchoolDetailsResponse, Error>
) =>
  useQuery<SchoolDetailsResponse, Error>({
    queryKey: ["school-details", filters],
    queryFn: () => fetchSchoolDetails(filters),
    ...options,
  });



export default useGetSchoolDetailsQuery;